import type { SVGProps } from 'react'
const SvgTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.66738 7.774L1.63292 4.78877L0.599609 5.79816L4.66738 9.79995L13.3996 1.20935L12.3736 0.199951L4.66738 7.774Z"
      fill="white"
    />
  </svg>
)
export default SvgTick
